/* tslint:disable */
/* eslint-disable */
/**
 * Zapper API
 * API to access zapper service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AuthenticateUser400Response
 */
export interface AuthenticateUser400Response {
    /**
     * 
     * @type {string}
     * @memberof AuthenticateUser400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface AuthenticateUser403Response
 */
export interface AuthenticateUser403Response {
    /**
     * 
     * @type {string}
     * @memberof AuthenticateUser403Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface AuthenticateUserRequest
 */
export interface AuthenticateUserRequest {
    /**
     * Numeric country code
     * @type {string}
     * @memberof AuthenticateUserRequest
     */
    'countryCode': string;
    /**
     * Numeric phone number
     * @type {string}
     * @memberof AuthenticateUserRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface DeleteAccount400Response
 */
export interface DeleteAccount400Response {
    /**
     * 
     * @type {string}
     * @memberof DeleteAccount400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface DeleteAccount403Response
 */
export interface DeleteAccount403Response {
    /**
     * 
     * @type {string}
     * @memberof DeleteAccount403Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface DeleteAccountRequest
 */
export interface DeleteAccountRequest {
    /**
     * Numeric phone number containing the country code
     * @type {string}
     * @memberof DeleteAccountRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface ProvideOtp400Response
 */
export interface ProvideOtp400Response {
    /**
     * 
     * @type {string}
     * @memberof ProvideOtp400Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ProvideOtp401Response
 */
export interface ProvideOtp401Response {
    /**
     * 
     * @type {string}
     * @memberof ProvideOtp401Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ProvideOtp403Response
 */
export interface ProvideOtp403Response {
    /**
     * 
     * @type {string}
     * @memberof ProvideOtp403Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ProvideOtp404Response
 */
export interface ProvideOtp404Response {
    /**
     * 
     * @type {string}
     * @memberof ProvideOtp404Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ProvideOtpRequest
 */
export interface ProvideOtpRequest {
    /**
     * One Time Password
     * @type {string}
     * @memberof ProvideOtpRequest
     */
    'otp': string;
    /**
     * Numeric phone number including country code
     * @type {string}
     * @memberof ProvideOtpRequest
     */
    'phoneNumber': string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Authenticate a user using their country code and phone number.
         * @summary User authentication
         * @param {AuthenticateUserRequest} authenticateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser: async (authenticateUserRequest: AuthenticateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authenticateUserRequest' is not null or undefined
            assertParamExists('authenticateUser', 'authenticateUserRequest', authenticateUserRequest)
            const localVarPath = `/api/v1/zapper/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a delete API call to the ACS.
         * @summary Delete the account
         * @param {DeleteAccountRequest} deleteAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (deleteAccountRequest: DeleteAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAccountRequest' is not null or undefined
            assertParamExists('deleteAccount', 'deleteAccountRequest', deleteAccountRequest)
            const localVarPath = `/api/v1/zapper/deleteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate a user using the OTP received on the previously provided phone number.
         * @summary User provide OTP to complete authentication
         * @param {ProvideOtpRequest} provideOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provideOtp: async (provideOtpRequest: ProvideOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provideOtpRequest' is not null or undefined
            assertParamExists('provideOtp', 'provideOtpRequest', provideOtpRequest)
            const localVarPath = `/api/v1/zapper/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(provideOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Authenticate a user using their country code and phone number.
         * @summary User authentication
         * @param {AuthenticateUserRequest} authenticateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateUser(authenticateUserRequest: AuthenticateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateUser(authenticateUserRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.authenticateUser']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Send a delete API call to the ACS.
         * @summary Delete the account
         * @param {DeleteAccountRequest} deleteAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(deleteAccountRequest: DeleteAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(deleteAccountRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.deleteAccount']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Authenticate a user using the OTP received on the previously provided phone number.
         * @summary User provide OTP to complete authentication
         * @param {ProvideOtpRequest} provideOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provideOtp(provideOtpRequest: ProvideOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.provideOtp(provideOtpRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DefaultApi.provideOtp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Authenticate a user using their country code and phone number.
         * @summary User authentication
         * @param {AuthenticateUserRequest} authenticateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser(authenticateUserRequest: AuthenticateUserRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authenticateUser(authenticateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a delete API call to the ACS.
         * @summary Delete the account
         * @param {DeleteAccountRequest} deleteAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(deleteAccountRequest: DeleteAccountRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAccount(deleteAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate a user using the OTP received on the previously provided phone number.
         * @summary User provide OTP to complete authentication
         * @param {ProvideOtpRequest} provideOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provideOtp(provideOtpRequest: ProvideOtpRequest, options?: any): AxiosPromise<void> {
            return localVarFp.provideOtp(provideOtpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Authenticate a user using their country code and phone number.
     * @summary User authentication
     * @param {AuthenticateUserRequest} authenticateUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public authenticateUser(authenticateUserRequest: AuthenticateUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).authenticateUser(authenticateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a delete API call to the ACS.
     * @summary Delete the account
     * @param {DeleteAccountRequest} deleteAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteAccount(deleteAccountRequest: DeleteAccountRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteAccount(deleteAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate a user using the OTP received on the previously provided phone number.
     * @summary User provide OTP to complete authentication
     * @param {ProvideOtpRequest} provideOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public provideOtp(provideOtpRequest: ProvideOtpRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).provideOtp(provideOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



